import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/app';
import { fetchListSupportProvider } from '../../../store/SupportProviderSlice';
import ToolBar from '../../../components/ToolBar';
import SearchSupportProvider from './components/SearchSupportProvider';
import AddSupportProvider from './components/AddSupportProvider';
import { Tabs } from 'antd';
import ListTable from './components/ListTable';
import EditSupportProvider from './components/EditSupportProvider';
import DeleteSupportProvider from './components/DeleteSupportProvider';

const SupportProvider: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const [tableloading, setTableLoading] = useState<boolean>(false);
    const [paginationData, setPaginationData] = useState<any>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [savePayload, setSavePayload] = useState<any>();
    const [listData, setListData] = useState<any[]>([]);
    const [totalData, setTotalData] = useState<any>(0);
    const [listHaveData, setListHaveData] = useState<boolean>(true);
    const [openEditModal, setOpenEditModal] = useState<boolean>(false);
    const [editModalData, seteditModalData] = useState<any>();
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [openDeleteData, setOpenDeleteData] = useState<any>();

    const getList = useCallback((data?: any) => {
        setTableLoading(true);
        const payload = {
            ...data,
            pageNumber: data?.pageNumber ?? paginationData?.pageNumber,
            pageSize: data?.pageSize ?? paginationData?.pageSize,
        };
        setSavePayload(payload);
        dispatch(fetchListSupportProvider(payload))
            .then((res: any) => {
                setListHaveData(false);
                setListData(res?.indexedResults);
                setTotalData(res?.totalRecords);
                setTableLoading(false);
            })
            .catch(() => {
                setListData([]);
                setTotalData(0)
                setTableLoading(false);
            });
    }, [paginationData, dispatch])
    useEffect(() => {
        if (listHaveData) {
            getList();
        }
    }, [getList, listHaveData]);
    const handleEditModal = (record: any) => {
        setOpenEditModal(!openEditModal);
        seteditModalData(record);
    };
    const handleDeleteRequest = (record: any) => {
        setOpenDeleteModal(!openDeleteModal);
        setOpenDeleteData(record);
    };
    return (
        <>
            <ToolBar title={'Email Support Providers'} />
            <Tabs
                defaultActiveKey="1"
                type="card"
                size="large"
                onChange={getList}
                items={[
                    {
                        key: '1',
                        label: 'Add Email Support Providers',
                        children: (
                            <AddSupportProvider
                                getList={getList}
                                totalData={totalData}
                            />
                        ),
                    },
                    {
                        key: '2',
                        label: 'Search Email Support Providers',
                        children: (
                            <SearchSupportProvider
                                getList={getList}
                                setPaginationData={setPaginationData}
                            />
                        ),
                    },
                ]}
            />
            <ListTable
                listData={listData}
                setListData={setListData}
                totalData={totalData}
                tableloading={tableloading}
                setTableLoading={setTableLoading}
                paginationData={paginationData}
                setPaginationData={setPaginationData}
                getList={getList}
                savePayload={savePayload}
                handleEditModal={handleEditModal}
                handleDeleteRequest={handleDeleteRequest}
            />
            <EditSupportProvider
                handleEditModal={handleEditModal}
                editModalData={editModalData}
                getList={getList}
                openEditModal={openEditModal}
            />
            <DeleteSupportProvider
                title={openDeleteData?.providers}
                close={handleDeleteRequest}
                open={openDeleteModal}
                deleteValues={openDeleteData}
                name={'Provider Code'}
                getList={getList}
            />
        </>
    )
}

export default SupportProvider